export function checkData(val){
    return (val !== undefined && val !== null && val !== '' && Object.entries(val).length >0 ) ? true : false; 
}
export function checkUndeNullBlank(val){
    return (val !== undefined && val !== null && val !== '') ? true : false; 
}
export function checkPermission(user, modules){

    return ((user[0].user_type === "Super") || (user[0].user_type === "SubAdmin" && modules)) ? true : false; 
}